import React from 'react';

import { CircularProgress, Button as MaterialButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import { ICustomButtonProps } from './AppBaseBlockButton';
import { useStyles } from './AppDashedBlockButton.styles';

export function AppDashedBlockButton({
  loader = false,
  children,
  variant = 'outlined',
  className,
  yPadding = 2,
  ...props
}: ICustomButtonProps) {
  const { classes } = useStyles({ yPadding });
  return (
    <MaterialButton
      variant={variant}
      className={clsx(classes.button, className)}
      {...props}
      disabled={props.disabled || loader}>
      {loader ? (
        <CircularProgress className={classes.circularProgress} size="20px" />
      ) : (
        children
      )}
    </MaterialButton>
  );
}

export default AppDashedBlockButton;
